import { render, staticRenderFns } from "./PackageClaimPost.vue?vue&type=template&id=7b889fa0&"
import script from "./PackageClaimPost.vue?vue&type=script&lang=js&"
export * from "./PackageClaimPost.vue?vue&type=script&lang=js&"
import style0 from "./PackageClaimPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageClaimPost.vue"
export default component.exports